import { render } from "./EditOffice.vue?vue&type=template&id=6e24e830&scoped=true&ts=true"
import script from "./EditOffice.vue?vue&type=script&lang=ts"
export * from "./EditOffice.vue?vue&type=script&lang=ts"

import "./EditOffice.vue?vue&type=style&index=0&id=6e24e830&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e24e830"]])

export default __exports__